import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { allValidations } from "../../utils/formValidations";
import { showFormErrors } from "../../utils/commonFunctions";
import { addOurClient, editOurClient, getOurClient } from "../../redux/actions/OurClientAction";

export default function OurClientContainer() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams();
    const [data, setData] = useState({
        title: "",
        description: "",
        name: "",
        image: "",
        role: "",
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            dispatch(
                getOurClient(id, (data) => {
                    setData({
                        title: data?.title,
                        description: data?.description,
                        name: data?.author?.name,
                        image: data?.author?.image,
                        role: data?.author?.role,
                    });
                })
            );
        }
    }, [id, dispatch]);

    const handleChange = ({ name, value }) => {
        const formErrors = allValidations(name, value, data);
        setData((prev) => ({ ...prev, [name]: name === 'image' ? value[0] : value, formErrors }));
    };

    const onSubmit = () => {
        if (showFormErrors(data, setData)) {
            if (id) {
                dispatch(editOurClient(id, data, setLoading, history));
            } else {
                dispatch(addOurClient(data, setLoading, history))
            }
        }
    };

    return { data, handleChange, loading, onSubmit };
}
